import { render, staticRenderFns } from "./ShortcutSection.vue?vue&type=template&id=1e2e42b0&scoped=true"
import script from "./ShortcutSection.vue?vue&type=script&lang=js"
export * from "./ShortcutSection.vue?vue&type=script&lang=js"
import style0 from "./ShortcutSection.vue?vue&type=style&index=0&id=1e2e42b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2e42b0",
  null
  
)

export default component.exports